import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "components/header";
import { GlobalContext } from "./contexts/global-context";
import VolksVale from "pages/volks-vale";
import Premios from "pages/premios";
import ModalAuth from "components/modal-auth";
import ModalAuthRevendedor from "components/modal-auth-revendedor";
import Regulamento from "pages/regulamento";
import Faq from "pages/faq";
import Modal from "components/modal";

export default () => {
    const [userName, setUserName] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenRevendedor, setIsModalOpenRevendedor] = useState(false);
    const [isModalOpenWinners, setIsModalOpenWinners] = useState(false);
    const globalContextValue = {
        userName,
        setUserName,
        isModalOpenWinners,
        setIsModalOpenWinners,
    };
    return (
        <GlobalContext.Provider value={globalContextValue}>
            <Router>
                <Header
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setIsModalOpenRevendedor={setIsModalOpenRevendedor}
                />
                <Switch>
                    <Route exact={true} path="/">
                        <VolksVale
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            isModalOpenRevendedor={isModalOpenRevendedor}
                            setIsModalOpenRevendedor={setIsModalOpenRevendedor}
                            isModalOpenWinners={isModalOpenWinners}
                            setIsModalOpenWinners={setIsModalOpenWinners}
                        />
                    </Route>
                    <Route exact={true} path="/premios">
                        <Premios
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                    <Route exact={true} path="/regulamento">
                        <Regulamento
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                    <Route exact={true} path="/faq">
                        <Faq
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                </Switch>
                <ModalAuth
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
                <ModalAuthRevendedor
                    isModalOpen={isModalOpenRevendedor}
                    setIsModalOpen={setIsModalOpenRevendedor}
                />
                <Modal
                    isOpen={isModalOpenWinners}
                    onClose={() => setIsModalOpenWinners(false)}
                >
                    <h2>Ganhadores</h2>
                    <table width="100%" className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th width="30%">Número da Sorte</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>LUCIANA GULES</td>
                                <td>02-10985</td>
                            </tr>
                            <tr>
                                <td>FABIANA BORGES DE CARVALHO MOREIRA</td>
                                <td>02-11024</td>
                                </tr>
                            <tr>
                                <td>ELISANGELA BRANCHER MACHADO</td>
                                <td>02-11038</td>
                            </tr>
                        </tbody>
                    </table>
                </Modal>
            </Router>
        </GlobalContext.Provider>
    );
};
